module.exports = __webpack_public_path__ + "img/home_up_disabled.4eb13dc7.svg";